import LookupItem from '../Domain/LookupItem';
import AuthService from './authService.js';
import SearchParams from '../Elements/SearchParams';
import LookupSearchParams from '../Contents/Administration/Lookup/LookupSearchParams';

export default class LookupService {
  static GetLookupItemList(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, LookupSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    const url = `/api/Lookup/GetLookups?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBItem(items) {
    let convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        let newItem = new LookupItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }
}
